module.exports = __webpack_public_path__ + "img/orange_087.f0535978.png";